import template from './closeable-pill.html';
import './closeable-pill.less';
import CloseablePillController from './closeable-pill.controller';

const CloseablePillComponent = {
  bindings: {
    key: '<',
    text: '<',
    close: '&'
  },
  template,
  controller: CloseablePillController
};

export default CloseablePillComponent;



// WEBPACK FOOTER //
// ./src/components/closeable-pill/closeable-pill.component.js